import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface FacebookProps {
  band: Band
}

export const Facebook: React.FC<FacebookProps> = ({ band }) => {
  const fieldData = {
    field: "facebook_url",
    name: "facebookUrl",
    label: "Your facebook page url",
    placeholder: "The url of your facebook page",
    required: false,
  }

  return <EditBandFormField type="text" fieldData={fieldData} />
}
